import requestFunctions from "../../functions/requestFunctions";


export const state = {
  BANK_ACCOUNTS_ITEM: {},
  BANK_ACCOUNTS_LIST: [],
  BANK_ACCOUNTS_TABLE_DATA: [],
  BANK_ACCOUNTS_ARRAY_DATA: [],
  BANK_ACCOUNTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_BANK_ACCOUNTS_ITEM: (state) => {
    return state.BANK_ACCOUNTS_ITEM;
  },
  GET_BANK_ACCOUNTS_LIST: (state) => {
    return state.BANK_ACCOUNTS_LIST;
  },
  GET_BANK_ACCOUNTS_TABLE_DATA: (state) => {
    return state.BANK_ACCOUNTS_TABLE_DATA;
  },
  GET_BANK_ACCOUNTS_ARRAY_DATA: (state) => {
    return state.BANK_ACCOUNTS_ARRAY_DATA;
  },
  GET_BANK_ACCOUNTS_TOTAL_ROWS: (state) => {
    return state.BANK_ACCOUNTS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_BANK_ACCOUNTS_ITEM(state, item) {
    state.BANK_ACCOUNTS_ITEM = item;
  },

  UPDATE_BANK_ACCOUNTS_LIST(state, list) {
    
    state.BANK_ACCOUNTS_LIST = list.data;

    state.BANK_ACCOUNTS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.BANK_ACCOUNTS_TABLE_DATA = [];
    state.BANK_ACCOUNTS_ARRAY_DATA = [];

    list.forEach(el => {

      state.BANK_ACCOUNTS_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'bik'  : el.bik,
        'inn'  : el.inn,
        'kpp'  : el.kpp,
        'ks'   : el.ks,
        'rs'   : el.rs,
        'bank_name'  : el.bank_name,
        'balance'    : el.balance,        
        'shop_name'  : el.shop_name,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
        'company_name' : el.company_name,        
      });

      state.BANK_ACCOUNTS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name
      });
    });
  },
}

export const actions = {

  async FETCH_BANK_ACCOUNTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/bank/accounts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BANK_ACCOUNTS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_BANK_ACCOUNTS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/bank/accounts';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BANK_ACCOUNTS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_BANK_ACCOUNTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/bank/accounts';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_BANK_ACCOUNTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/bank/accounts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_BANK_ACCOUNTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/bank/accounts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}